import { NgModule } from '@angular/core';
import { CharterBuyflowVesselDetailComponent } from './charter-buyflow-vessel-detail.component';
import { CharterBuyflowVesselDetailRoutingModule } from './charter-buyflow-vessel-detail-routing.module';
import { SwiperCarouselModule } from '../../../shared/public-components/swiper-carousel/swiper-carousel.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { CommonModule } from '@angular/common';
import { RequestBookingFormModule } from '../../../shared/public-components/request-booking-form/request-booking-form.module';
import { AppBuflowMapModule } from '../../../shared/app-buyflow-map/app-buyflow-map.module';
import { LoadingModule } from '../../../shared/loading/loading.module';
import { CharterBuyflowVesselDetailResolve } from './charter-buyflow-vessel-detail.resolve';
import { AffiliateValidityModule } from '../../../affiliate/affiliate-validity/affiliate-validity.module';
import { AffiliateLinkCopyModule } from '../../../affiliate/affiliate-link-copy/affiliate-link-copy.module';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MobileBookingAvailabilityModule } from '../mobile-booking-availability/mobile-booking-availability.module';
import { VesselPhotoGalleryModule } from '../../../shared/public-components/photo-gallary/vessel-photo-gallery.module';
import { BookingDescriptionDialogModule } from '../../../shared/dialogs/booking-description-dialog/booking-description-dialog.module';
import { AmenitiesDialogModule } from '../../../shared/dialogs/amenities-dialog/amenities-dialog.module';
import { BoatRulesDialogModule } from '../../../shared/dialogs/boat-rules-dialog/boat-rules-dialog.module';
import { BuyflowCancellationDialogModule } from '../../../shared/dialogs/buyflow-cancellation-dialog/buyflow-cancellation-dialog.module';
import { BuyflowDepositDialogModule } from '../../../shared/dialogs/buyflow-deposit-dialog/buyflow-deposit-dialog.module';
import { MatTabsModule } from '@angular/material/tabs';
import { RoundDownPipe } from '../../../shared/pipes/roundDown.pipe';
import { CustomerAddOnsDialogModule } from '../../../shared/dialogs/customer-add-ons-dialog/customer-add-ons-dialog.module';
import { VesselReviewsModule } from '../../vessel-reviews/vessel-reviews.module';

@NgModule({
  imports: [
    CharterBuyflowVesselDetailRoutingModule,
    SwiperCarouselModule,
    MatIconModule,
    CommonModule,
    RequestBookingFormModule,
    AppBuflowMapModule,
    MatButtonModule,
    LoadingModule,
    MatStepperModule,
    AffiliateValidityModule,
    AffiliateLinkCopyModule,
    MatBottomSheetModule,
    MobileBookingAvailabilityModule,
    VesselPhotoGalleryModule,
    BookingDescriptionDialogModule,
    AmenitiesDialogModule,
    BoatRulesDialogModule,
    BuyflowCancellationDialogModule,
    BuyflowDepositDialogModule,
    MatTabsModule,
    CustomerAddOnsDialogModule,
    VesselReviewsModule,
  ],
  declarations: [CharterBuyflowVesselDetailComponent],
  entryComponents: [CharterBuyflowVesselDetailComponent],
  exports: [CharterBuyflowVesselDetailComponent],
  providers: [CharterBuyflowVesselDetailResolve, RoundDownPipe],
})
export class CharterBuyflowVesselDetailModule {
  // WIP :: ATTEMPT TO PREVENT SCROLL ON CHARTER TYPE CHANGE
  // constructor(router: Router, viewportScroller: ViewportScroller) {
  //   router.events.pipe(
  //     filter((e) => e instanceof Scroll)
  //   ).subscribe(e => {
  //     if (!router.url.includes('yacht-and-boat-rentals')) {
  //       viewportScroller.scrollToPosition([0, 0]);
  //     }
  //   });
  // }
}
